export interface ChecklistItem {
  id: string
  label: string
  order: number
  systemId: string
  systemLabel: string
  systemOrder: number
}

const systems = [
  {
    id: '1',
    label: 'Estrutura',
    items: [
      'Trincas na estrutura',
      'Trincas nos braços',
      'Trincas na caçamba/implementos',
      'Soldas e reforços',
      'Pinos e buchas da estrutura',
    ],
  },
  {
    id: '2',
    label: 'Sistema hidráulico',
    items: [
      'Mangueiras',
      'Cilindros',
      'Bomba hidráulica',
      'Comandos hidráulicos',
      'Pressão do sistema',
      'Vazamentos',
    ],
  },
  {
    id: '3',
    label: 'Sistema de combustível',
    items: [
      'Nível do combustível',
      'Filtro de combustível',
      'Bomba de alimentação',
      'Bomba de alta pressão',
      'Unidades injetoras',
      'Linhas e conexões',
      'Vazamentos',
    ],
  },
  {
    id: '4',
    label: 'Motor',
    items: [
      'Nível do óleo',
      'Pressão do óleo',
      'Sistema de arrefecimento',
      'Filtros: óleo, diesel e ar',
      'Correias',
      'Pressão de óleo do motor',
      'Regulagem de válvulas',
      'Chicote elétrico e conectores',
    ],
  },
  {
    id: '5',
    label: 'Transmissão',
    items: [
      'Nível do óleo',
      'Pressão de óleo',
      'Sistema de arrefecimento',
      'Ruídos e vibrações',
      'Funcionamento: avanço e ré',
    ],
  },
  { id: '6', label: 'Freios', items: ['Pressão', 'Bomba', 'Vazamentos', 'Funcionamento'] },
  {
    id: '7',
    label: 'Pneus/Esteiras',
    items: ['Estado geral', 'Desgaste', 'Tensão das esteiras'],
  },
] as const

export const CHECKLIST_VERSION = 1

export const CHECKLIST_ITEMS: readonly ChecklistItem[] = systems.flatMap((system, systemIndex) =>
  system.items.map((label, itemIndex) => ({
    id: `${system.id}.${itemIndex + 1}`,
    label,
    order:
      systems.slice(0, systemIndex).reduce((total, current) => total + current.items.length, 0) +
      itemIndex +
      1,
    systemId: system.id,
    systemLabel: system.label,
    systemOrder: systemIndex + 1,
  })),
)

if (CHECKLIST_ITEMS.length !== 38) {
  throw new Error('O checklist oficial precisa conter exatamente 38 itens.')
}
